import { createSlice } from '@reduxjs/toolkit';
import {
  CreateReview,
  DeleteReview,
  EditReviewDetail,
  GetAllMajorReview,
  GetAllReview,
  GetSingleReviewDetails,
  SearchForReviewsByName,
  UploadReviewIcon,
  UploadReviewImage,
} from './review_services_sync';

export const reviewSlice = createSlice({
  name: 'review',
  initialState: {
    review_loader: false,
    allReviewLoader: true,
    reviewDeleteLoader: false,
    reviewEditLoader: false,
    rvwEditLoader: false,
    message: '',
    completeReview: {},
    completeMajorReview: [],
    reviewDetails: {},
    reviewImageDetails: {},
    reviewIconDetails: {},
    completeReviewSearch: {},
    review_page: 0,
    review_limit: 10,
    editReviewId: '',
  },
  reducers: {
    clearState: (state) => {
      state.review_loader = false;
      state.message = '';
      state.completeReview = {};
      state.completeMajorReview = [];
      state.allReviewLoader = true;
      state.reviewDeleteLoader = false;
      state.reviewEditLoader = false;
      state.rvwEditLoader = false;
      state.reviewDetails = {};
      state.completeReviewSearch = {};
      state.reviewImageDetails = {};
      state.reviewIconDetails = {};
      state.editReviewId = '';

      return state;
    },

    updateReviewDetails: (state, action) => {
      state.reviewDetails = action.payload;
    },

    updateCompleteReview: (state, action) => {
      state.completeReview = action.payload;
    },
    updateReviewId: (state, { payload }) => {
      state.editReviewId = payload;
    },

    updateReviewImageDetails: (state, { payload }) => {
      state.reviewImageDetails = payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(CreateReview.pending, (state) => {
        state.review_loader = true;
      })
      .addCase(CreateReview.fulfilled, (state, { payload }) => {
        state.review_loader = false;
        state.message = payload.message;
        state.reviewImageDetails = {};
      })
      .addCase(CreateReview.rejected, (state, { payload }) => {
        state.review_loader = false;
        state.message = payload.message;
      })
      .addCase(UploadReviewImage.pending, (state) => {
        state.reviewEditLoader = true;
      })
      .addCase(UploadReviewImage.fulfilled, (state, { payload }) => {
        state.reviewEditLoader = false;
        state.profileMessage = payload.message;
        state.reviewImageDetails = payload.data;
      })
      .addCase(UploadReviewImage.rejected, (state, { payload }) => {
        state.reviewEditLoader = false;
        state.profileMessage = payload?.message;
      })
      .addCase(UploadReviewIcon.pending, (state) => {
        state.reviewEditLoader = true;
      })
      .addCase(UploadReviewIcon.fulfilled, (state, { payload }) => {
        state.reviewEditLoader = false;
        state.profileMessage = payload.message;
        state.reviewIconDetails = payload.data;
      })
      .addCase(UploadReviewIcon.rejected, (state, { payload }) => {
        state.reviewEditLoader = false;
        state.profileMessage = payload?.message;
      })
      .addCase(GetAllReview.pending, (state) => {
        state.review_loader = true;
      })
      .addCase(GetAllReview.fulfilled, (state, { payload }) => {
        state.review_loader = false;
        state.message = payload.message;
        state.completeReview = payload.data;
        state.review_page = payload?.data?.page;
      })
      .addCase(GetAllReview.rejected, (state, { payload }) => {
        state.review_loader = false;
        state.message = payload.message;
      })
      .addCase(GetAllMajorReview.pending, (state) => {
        state.review_loader = true;
      })
      .addCase(GetAllMajorReview.fulfilled, (state, { payload }) => {
        state.review_loader = false;
        state.message = payload.message;
        state.completeMajorReview = payload.data;
      })
      .addCase(GetAllMajorReview.rejected, (state, { payload }) => {
        state.review_loader = false;
        state.message = payload.message;
      })
      .addCase(DeleteReview.pending, (state) => {
        state.reviewDeleteLoader = true;
      })
      .addCase(DeleteReview.fulfilled, (state, { payload }) => {
        const filterData = state.completeReview?.docs?.filter(
          (item) => item._id !== payload?.data?._id
        );

        state.completeReview = {
          ...state.completeReview,
          docs: filterData,
        };

        state.reviewDeleteLoader = false;
        state.message = payload.message;

        state.editReviewId = '';
      })
      .addCase(DeleteReview.rejected, (state, { payload }) => {
        state.reviewDeleteLoader = false;
        state.message = payload.message;
        state.editReviewId = '';
      })
      .addCase(GetSingleReviewDetails.pending, (state) => {
        state.review_loader = true;
      })
      .addCase(GetSingleReviewDetails.fulfilled, (state, { payload }) => {
        state.review_loader = false;
        state.message = payload.message;
        state.reviewDetails = payload.data;
      })
      .addCase(GetSingleReviewDetails.rejected, (state, { payload }) => {
        state.review_loader = false;
        state.message = payload.message;
      })
      .addCase(EditReviewDetail.pending, (state) => {
        state.rvwEditLoader = true;
      })
      .addCase(EditReviewDetail.fulfilled, (state, { payload }) => {
        state.rvwEditLoader = false;
        state.message = payload.message;

        state.reviewImageDetails = {};
      })
      .addCase(EditReviewDetail.rejected, (state, { payload }) => {
        state.rvwEditLoader = false;
        state.message = payload.message;
      })

      .addCase(SearchForReviewsByName.pending, (state) => {
        state.review_loader = true;
      })
      .addCase(SearchForReviewsByName.fulfilled, (state, { payload }) => {
        state.review_loader = false;
        state.message = payload?.message;

        state.completeReviewSearch = payload?.data;
      })
      .addCase(SearchForReviewsByName.rejected, (state, { payload }) => {
        state.review_loader = false;
        state.message = payload?.message;
      });
  },
});

export const {
  updateReviewDetails,
  updateCompleteReview,
  updateReviewId,
  updateReviewImageDetails,
} = reviewSlice.actions;
export const reviewSelector = (state) => state.review;

export default reviewSlice.reducer;
